const Logan = Mach.requireModule('Logan');

const safeSchemeParams = Mach.env?.schemeParams || {};
const defaultTags = {
  componentId: 'c_channel_list_main_logan',
  cid: safeSchemeParams.cid || '',
  bid: safeSchemeParams.bid || '',
  specialScene: safeSchemeParams.specialScene || '',
};

const ChannelCommonListPageLoganType = {
  API: 'ChannelCommonListPageAPI',
  Main: 'ChannelCommonListPageMain',
  Header: 'ChannelCommonListPageHeader',
  Feed: 'ChannelCommonListPageFeed',
};

/**
 * logan上报
 * @param loganType
 * @param logData
 */
function logan(loganType, logData) {
  if (Logan) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      if (logStr) {
        Logan.log(logStr);
      }
    } catch (error) {
      //
    }
  }

  if (Mach.env.isDebug) {
    try {
      const logStr = JSON.stringify({ ...defaultTags, ...logData, loganType });
      console.log(logStr);
    } catch (error) {
      console.log('Logan ❌❌❌❌❌=====', error);
    }
  }
}

export { logan, ChannelCommonListPageLoganType };
